import BetaSwitch from './BetaSwitch';

export default BetaSwitch;
